import type { RatedProductWire } from 'shared';
import { cart, ratedProducts } from '@/state/session.js';

export interface RatedProductGroup {
  productId: string;
  /** `quote_item_id`s for this product's tiers, ascending by term_months. */
  quoteItemIds: string[];
}

/** Preserves first-seen product order and sorts each product's tiers by term length. */
export function groupByProduct(rated: RatedProductWire[]): RatedProductGroup[] {
  const order: string[] = [];
  const buckets = new Map<string, RatedProductWire[]>();
  for (const tier of rated) {
    let bucket = buckets.get(tier.product_id);
    if (bucket === undefined) {
      bucket = [];
      order.push(tier.product_id);
      buckets.set(tier.product_id, bucket);
    }
    bucket.push(tier);
  }
  return order.map((productId) => {
    const tiers = [...buckets.get(productId)!].sort((a, b) => a.term_months - b.term_months);
    return { productId, quoteItemIds: tiers.map((t) => t.quote_item_id) };
  });
}

/**
 * What's left to offer. A membership test rather than a count, because a re-rate can retire
 * a cart entry and make the counts lie.
 */
export function groupsNotInCart(): RatedProductGroup[] {
  const chosen = new Set(cart.value.map((e) => e.quoteItemId));
  return groupByProduct(ratedProducts.value).filter(
    (g) => !g.quoteItemIds.some((id) => chosen.has(id)),
  );
}
